<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #universityPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="universityFiltersPopover" (click)="universityFiltersPopover.toggle()"
                [class.results-listing__filter--active]="universityPopoverAnchor.isPopoverOpen()">
          University Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #universityListEl *ngIf="universities && universities.length > 0; else placeholder" class="results-listing__list">
        <a class="university-card"
           #universityEl *ngFor="let university of universities"
           [class.university-card--active]="university === activeUniversity"
           [routerLink]="['/business', university.businessId]"
           (click)="onUniversitySelected()"
           (mouseenter)="onUniversityHover(university, true)"
           (mouseleave)="onUniversityHover(university, false)">
          <div class="university-card__type-row">
            <span class="university-card__type">{{ university.degrees && university.degrees.length ? university.degrees.join(' · ') : 'University' }}</span>
            <span class="university-card__flag" *ngIf="university.vaApproved">VA Approved</span>
          </div>
          <div class="university-card__main">
            <div class="university-card__content">
              <h2 class="university-card__name">{{ university.name }}</h2>
              <div class="university-card__body">
                <div class="university-card__text" *ngIf="university.airportName || university.airportIdent">
                  <ng-container *ngIf="university.airportName">{{ university.airportName }}</ng-container><ng-container *ngIf="university.airportName && university.airportIdent"> - </ng-container><ng-container *ngIf="university.airportIdent">({{ university.airportIdent }})</ng-container>
                </div>
                <div class="university-card__text" *ngIf="university.city || university.stateProvince">
                  {{ university.city }}<ng-container *ngIf="university.city && university.stateProvince">, </ng-container>{{ university.stateProvince }}
                </div>
                <div class="university-card__text university-card__detail" *ngIf="university.distanceLearning">
                  Distance learning available
                </div>
              </div>
            </div>
            <div class="university-card__photo" *ngIf="university.thumbnailPhotoPath">
              <img class="university-card__image" [src]="university.thumbnailPhotoPath" alt="" />
            </div>
          </div>
        </a>
      </div>
      <mat-paginator
        *ngIf="universities && universities.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalUniversities"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #universityFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-university-finder-filter-list #universityFilters [query]="query" [compact]="true"
                                       (filtersChange)="onFiltersChanged()">
    </app-university-finder-filter-list>
  </div>
</sat-popover>
